import { render, staticRenderFns } from "./TelQuesting.vue?vue&type=template&id=0bb0fc7e&scoped=true"
import script from "./TelQuesting.vue?vue&type=script&lang=js"
export * from "./TelQuesting.vue?vue&type=script&lang=js"
import style0 from "./TelQuesting.vue?vue&type=style&index=0&id=0bb0fc7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb0fc7e",
  null
  
)

export default component.exports